import request from '@/utils/request';

// 导出任务列表
export const taskImportList = (params: any) =>
  request({
    url: 'TaskImport/taskImportList',
    method: 'get',
    params
  });
